<template>
  <div class="modal-backdrop">
    <div class="modal-content">
      <h3>
        Review Gun <i>{{ gun.gun_name }}</i>
      </h3>
      <h4>Powder Output Measurements need to be reviewed</h4>
      <SteelCaseGunsEqualizationChart
        :datasets="[gunDataset]"
        :powder-output-measurements="gunPowderOutputMeasurements"
        :show-controls="false"
      />
      <div class="actions">
        <button
          class="btn accept"
          @click="acceptMeasurement"
        >
          Accept Model
        </button>
        <button
          class="btn alert"
          @click="reviewBagging"
        >
          Review Bagging
        </button>
        <button
          class="btn reject"
          @click="discardMeasurement"
        >
          Discard Measurement
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SteelCaseGunsEqualizationChart from "./SteelCaseGunsEqualizationChart.vue";

export default {
  name: "BaggingGunReviewModal",
  components: {
    SteelCaseGunsEqualizationChart,
  },
  props: {
    gun: {
      type: Object,
      required: true,
    },
    gunDataset: {
      type: Object,
      required: true,
    },
    gunPowderOutputMeasurements: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["validated"],
  methods: {
    reviewBagging() {
      this.$emit("validated", { gun: this.gun, status: "reviewing_bagging" });
    },
    discardMeasurement() {
      this.$emit("validated", { gun: this.gun, status: "rejected" });
    },
    acceptMeasurement() {
      this.$emit("validated", { gun: this.gun, status: "valid" });
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 800px;
  max-width: 90%;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}
.btn {
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.accept {
  background: #4caf50;
  color: white;
}
.alert {
  background: #ff9800;
  color: white;
}
.reject {
  background: #f44336;
  color: white;
}
</style>
